import { type IContent } from "@kunduz/data-access-cms-api";
import { AccordionTypes } from "./accordionTypes";
import {
  PlanDetailAccordionCarousel,
  PlanDetailAvatarGroup,
  PlanDetailBulletList,
  PlanDetailDescriptionPlainText,
  PlanDetailInstallmentTable,
  PlanDetailLogoList,
  PlanDetailPlainText,
} from "../planDetailV2";
import { Divider } from "@kunduz/ui";
import { gray } from "../../theme";

function AccordionSubComponentSwitcher(props: {
  data: IContent.DetailedAccordionData["options"][0]["items"][0]["items"][0];
}) {
  switch (props.data.type) {
    case AccordionTypes.AccordionInstallmentGroupItem:
      return <PlanDetailInstallmentTable data={props.data.data} />;
    case AccordionTypes.AccordionBulletGroupItem:
      return <PlanDetailBulletList data={props.data.data} />;
    case AccordionTypes.AccordionPlainTextItem:
      return <PlanDetailPlainText data={props.data.data} />;
    case AccordionTypes.AccordionDescriptionPlainTextItem:
      return <PlanDetailDescriptionPlainText data={props.data.data} />;
    case AccordionTypes.AccordionCarouselOption:
      return <PlanDetailAccordionCarousel data={props.data.data} />;
    case AccordionTypes.AccordionImageGroupItem:
      return <PlanDetailAvatarGroup data={props.data.data} />;
    case AccordionTypes.LogoListGroupComponent:
      return <PlanDetailLogoList data={props.data.data} />;

    default:
      return <></>;
  }
}

/**
 * accordion data has both legacy description and items
 * this code sanitizes it
 */
export function AccordionChildren(props: {
  accordionItemDesc?: string;
  items?: IContent.DetailedAccordionData["options"][0]["items"][0]["items"];
}) {
  const legacy: { type: AccordionTypes; data: { text: string } }[] = [];

  if (props.accordionItemDesc) {
    legacy.push({
      type: AccordionTypes.AccordionDescriptionPlainTextItem,
      data: {
        text: props.accordionItemDesc,
      },
    });
  }

  const computed =
    [...legacy, ...(props.items || [])]?.map((subitem, subkey) => (
      <AccordionSubComponentSwitcher data={subitem} key={`subkey_${subkey}`} />
    )) || [];

  if (!computed || computed.length == 0) {
    return [];
  }

  return computed
    .reduce(
      (arr, b, index) =>
        [
          ...arr,
          b,
          <Divider
            top={0}
            bottom={0}
            color={gray[200]}
            key={`divider_${index}`}
          />,
        ] as any,
      [],
    )
    .slice(0, -1);
}
